import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Corporation } from '../../organization.types';

@Injectable({ providedIn: 'root' })
export class CompanyImpactProfileService {
    private _corporation: BehaviorSubject<Corporation | null> =
        new BehaviorSubject<Corporation | null>(null);
    private _shouldDisplayProfileActions = new BehaviorSubject<boolean>(false);

    get corporation$(): Observable<Corporation | null> {
        return this._corporation.asObservable();
    }

    get shouldDisplayProfileActions$(): Observable<boolean> {
        return this._shouldDisplayProfileActions.asObservable();
    }

    set corporation(value: Corporation | null) {
        this._corporation.next(value);
    }

    set shouldDisplayProfileActions(value: boolean) {
        this._shouldDisplayProfileActions.next(value);
    }
}
